import Check from '@mui/icons-material/Check';
import { useTheme } from '@mui/material';
import Box from '@mui/material/Box';
import MenuItem, { MenuItemProps } from '@mui/material/MenuItem';
import Typography from '@mui/material/Typography';

interface CheckableMenuItemProps extends MenuItemProps {
  isChecked: boolean;
  label: string;
}

export default function CheckableMenuItem({
  isChecked,
  label,
  ...menuItemProps
}: CheckableMenuItemProps) {
  const theme = useTheme();

  return (
    <MenuItem {...menuItemProps}>
      <Box
        sx={{
          alignItems: 'center',
          display: 'flex',
          justifyContent: 'space-between',
          width: '100%',
        }}
      >
        <Typography variant="subtitle2" sx={{ color: theme.brandV2.colors.treadBlack }}>
          {label}
        </Typography>
        {isChecked && (
          <Check sx={{ fontSize: '16px', color: theme.brandV2.colors.treadOrange }} />
        )}
      </Box>
    </MenuItem>
  );
}
